module.exports = __webpack_public_path__ + "img/banne04_logo.726c3ede.png";